<!-- Active Filters Display Component - TK 01/15/2025 -->
@if (hasActiveFilters) {
  <div class="active-filters-container">
    <mat-card class="filters-card">
      <mat-card-header class="filters-header">
        <mat-card-title class="filters-title">
          <mat-icon class="filter-icon">filter_list</mat-icon>
          {{ title }} ({{ activeFiltersCount }})
        </mat-card-title>
        <div class="filters-actions">
          <!-- Filter Button - TK 01/15/2025 -->
          @if (showFilterButton) {
            <button
              mat-icon-button
              (click)="onOpenFilterDialog()"
              [matTooltip]="filterButtonTooltip"
              class="filter-button"
            >
              <mat-icon>filter_list</mat-icon>
            </button>
          }

          <button
            mat-icon-button
            (click)="toggleExpanded()"
            [attr.aria-label]="
              isExpanded ? 'Collapse filters' : 'Expand filters'
            "
            class="toggle-button"
          >
            <mat-icon>{{
              isExpanded ? 'expand_less' : 'expand_more'
            }}</mat-icon>
          </button>
          @if (showClearAll) {
            <button
              mat-icon-button
              (click)="onClearAll()"
              aria-label="Clear all filters"
              class="clear-all-button"
              matTooltip="Clear all filters"
            >
              <mat-icon>clear_all</mat-icon>
            </button>
          }
        </div>
      </mat-card-header>

      <mat-card-content class="filters-content" [class.expanded]="isExpanded">
        @if (isExpanded) {
          <div class="filters-list">
            @for (column of getFilterEntries(); track column.key) {
              <mat-chip
                [value]="column.key"
                [class]="
                  'filter-chip ' +
                  (isDefaultFilter(column.key)
                    ? 'default-filter'
                    : 'custom-filter')
                "
                [removable]="!isDefaultFilter(column.key)"
                (removed)="onClearFilter(column.key)"
              >
                <span class="filter-label">{{
                  getFilterDisplayValue(column.key, column.value)
                }}</span>
                <mat-icon matChipRemove class="remove-icon">cancel</mat-icon>
              </mat-chip>
            }
          </div>
        }

        <!-- Compact view when collapsed -->
        @if (!isExpanded) {
          <div class="filters-summary">
            <span class="summary-text">
              {{ activeFiltersCount }} filter{{
                activeFiltersCount > 1 ? 's' : ''
              }}
              applied
            </span>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
}
